// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import PrimeVue from 'primevue/config';
import DialogService from 'primevue/dialogservice';
import 'primevue/resources/themes/aura-dark-indigo/theme.css'; 
import 'primevue/resources/primevue.min.css';
import 'primeicons/primeicons.css'; 
import 'primeflex/primeflex.css';
import "@/assets/css/LoadingAnimation.css";
import "@/assets/css/main.css";
import router from '@/router';
import apiClient from '@/axios-config'; 
import store from '@/store';

import { auth, refreshUserToken } from './firebase'; // Update import
import { onAuthStateChanged } from 'firebase/auth'; // Import onAuthStateChanged

import ConfirmDialog from 'primevue/confirmdialog';
import ConfirmationService from 'primevue/confirmationservice';
import Tooltip from 'primevue/tooltip';

const app = createApp(App);

// Configure app
app.use(PrimeVue);
app.use(router); 
app.use(store);
app.use(DialogService);
app.use(ConfirmationService);
app.directive('tooltip', Tooltip);
app.component('ConfirmDialog', ConfirmDialog);
app.config.globalProperties.$http = apiClient;

// Create a promise to track the initial auth state
const getCurrentUser = () => {
  return new Promise((resolve, reject) => {
    const unsubscribe = onAuthStateChanged(auth, 
      (user) => {
        unsubscribe();
        resolve(user);
      },
      reject
    );
  });
};

// Add this function after app creation
function setupTokenRefresh(store) {
  setInterval(async () => {
    if (store.getters.isAuthenticated && store.getters.shouldRefreshToken) {
      try {
        const newToken = await refreshUserToken();
        if (newToken) {
          await store.dispatch('updateToken', newToken); // Assuming you have this mutation
        }
      } catch (error) {
        console.error('Periodic token refresh failed:', error);
      }
    }
  }, 60000); // Check every minute
}

// Modify initializeApp function
async function initializeApp() {
  try {
    const user = await getCurrentUser();
    if (user) {
      // Force a token refresh on initial load to get latest claims
      const idToken = await refreshUserToken();
      await store.dispatch('login', { user, idToken });
    }
    
    // Setup token refresh mechanism
    setupTokenRefresh(store);
    
    // Mount the app after authentication is initialized
    app.mount('#app');
  } catch (error) {
    console.error('Auth initialization error:', error);
    app.mount('#app');
  }
}

initializeApp();

// Router guards
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!auth.currentUser) {
      next({ name: 'Login' });
    } else {
      next();
    }
  } else {
    next();
  }
});
